import React from "react";
import { BsGlobe } from "react-icons/bs";
import { MdOutlinePhone } from "react-icons/md";
import footerlogo from "../assets/images/footer_logo.png";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="flex-container">
          <div className="flex-item">
            <h6 style={{ fontSize: "20px" }}>Hosecraft USA</h6>
            <p style={{ color: "black" }}>
              <BsGlobe style={{ color: "var(--primary)" }} />: www.hosecraftusa.com, sales@hosecraftusa.com
            </p>
            <p style={{ marginTop: "-12px", color: "black" }}>
              <MdOutlinePhone style={{ color: "var(--primary)" }} />: +1 312-229-7550
            </p>
          </div>
          <div className="flex-item2">
            <img
              src={footerlogo}
              alt=""
              style={{
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
            />
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
